import FancyNav from './FancyNav';

export default FancyNav;
